import { makeStyles } from 'tss-react/mui';
import { colors, spacing } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme, { featuredBackground, featuredHeadingColour, hasFeaturedPadding } = {}) => {
    var _a, _b;
    return ({
        title: Object.assign(Object.assign(Object.assign({}, theme.typography.medium_bold), (_a = theme.typographySpacing) === null || _a === void 0 ? void 0 : _a.medium_bold_lg), { lineHeight: '28px', textAlign: 'center', [theme.breakpoints.up('md')]: Object.assign(Object.assign(Object.assign({}, theme.typography.large_bold), (_b = theme.typographySpacing) === null || _b === void 0 ? void 0 : _b.large_bold_sm), { textAlign: 'left' }) }),
        bottomLinkWrapper: {
            height: '52px',
            boxSizing: 'border-box',
            display: 'flex',
            alignItems: 'center',
            paddingLeft: `calc(${spacing.medium} + ${spacing.small})`,
            borderBottom: `1px solid ${colors.grey.grey3}`,
            textAlign: 'left',
        },
        bottomLink: Object.assign(Object.assign({}, theme.typography.small_regular), { lineHeight: '28px', letterSpacing: '0.4px', textDecoration: 'underline', color: colors.supplementary.black, display: 'inline-block', transition: 'color 0.2s ease', '&:hover': {
                color: colors.grey.grey6,
                textDecoration: 'underline',
                cursor: 'pointer',
            } }),
        featuredRoot: {
            backgroundColor: featuredBackground,
            padding: hasFeaturedPadding ? spacing.small : 0,
        },
        featuredTitle: Object.assign(Object.assign(Object.assign({}, theme.typography.medium_bold), (theme.isFlyingFlowers ? {} : { lineHeight: '1.75rem' })), { color: featuredHeadingColour, textAlign: 'center', margin: `0 0 ${spacing.xs} 0`, [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.large_bold), { textAlign: 'left', margin: `0 0 ${spacing.small} 0` }) }),
        featuredList: {
            display: 'flex',
            flexDirection: 'column',
            gap: spacing.small,
            [theme.breakpoints.up('md')]: {
                flexDirection: 'row',
                alignItems: 'stretch',
            },
        },
        gallerySpacer: {
            height: spacing.small,
        },
        anchorSpacer: {
            height: '100vh',
            border: '1px solid red',
        },
    });
});
export default useStyles;
